
import { defineComponent, PropType } from 'vue';
import { NCollapse, NCollapseItem } from 'naive-ui'

import { StationGroup } from '../../api/models/station-group.model';
import { Station } from '../../api/models/station.model';

import StationListItem from '~/components/station-list/station-list-item';

export default defineComponent({

    components: {
        NCollapse,
        NCollapseItem,
        StationListItem,
    },

    props: {
        groups: { type: Array as PropType<StationGroup[]>},
        current: { type: Object as PropType<Station>},
    },

    methods: {
        onStationSelected(station: Station): void {
            if(!station) {
                return;
            }

            this.$router.replace({ query: { ...this.$route.query, station: station.id } });
        }
    },
})
